module.exports = __webpack_public_path__ + "static/media/dots-menu.0ca5cbe3.svg";